/* When it's time to convert other clients, please find client-specific requirements here - CLPL-19684 */
import React from 'react';
import { useSelector } from 'react-redux';
import Tooltip from 'core/modules/Partials/Tooltip/Tooltip';
import orgConfig from 'org/configs/org.config';
import { selectSiteUrl } from 'core/selectors/app';

function PostingTimeTooltip() {
  const { earnType } = orgConfig;
  const siteUrl = useSelector(selectSiteUrl);
  const tooltipHtml = (
    <>
      <div className="mn_tipTitle">About estimated posting times</div>
      <div className="mn_tipBody">
        Posting times shown here are estimates and are not a guarantee of timing.
        Per program <a href={`${siteUrl}/faq____.htm`}>FAQs</a>, {earnType} can take up to
        15 days to post. For purchases that take over 15 days to post, please
        contact <a href={`${siteUrl}/contact____.htm`}>customer care</a> for assistance.
      </div>
    </>
  );

  return (
    <Tooltip content={tooltipHtml} direction="top" useDefaultInfoIcon>
      <span className="mn_tooltipIcon" role="tooltip" aria-label="info icon" />
    </Tooltip>
  );
}

export default PostingTimeTooltip;
